// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3xdoM","additionalInfo":"AgreementModal_additionalInfo__dwVM4"};